export const css = {
	oneaction: '_3Is15n-m',
	' _key': 'certwise-theme/certwise/quiz-widgets/prometric-review'
};

export default css;
